import { FormControl, FormHelperText, TextField } from "@mui/material";
import { FC } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import {
  IInput,
  IMuiFormControl,
  VALIDATE_EMAIL_REGEXP,
  ValidationHelpers,
} from "@ryde/shared";

export const EmailInputByControl: FC<IMuiFormControl & IInput> = ({
  control,
  name,
  formLabel,
  formValidation,
  e2eData = "email-input",
  size = "medium",
  sx,
  tabIndex,
}) => {
  const { t } = useTranslation();
  return name ? (
    <div dir={"ltr"}>
      <Controller
        name={name}
        control={control}
        rules={{
          pattern: {
            value: VALIDATE_EMAIL_REGEXP,
            message: t("errors.invalidEmail"),
          },
        }}
        render={({ field, fieldState: { error } }) => (
          <FormControl error={!!error}>
            <TextField
              {...field}
              type={"email"}
              data-e2e={e2eData}
              label={formLabel}
              required={ValidationHelpers.hasRequiredRule(formValidation)}
              error={!!error}
              size={size}
              sx={sx}
              fullWidth
              tabIndex={tabIndex}
            />
            {/*TODO: add translation solution*/}
            {error && <FormHelperText>{error.message}</FormHelperText>}
          </FormControl>
        )}
      />
    </div>
  ) : null;
};
